import { FavoriteStandardMedicine } from "../../models/medic/favorite-standard-medicine.model";
import { FavoriteMedicatedSolutionStruct } from "../../structs/medic/favorite-medicated-solution.struct";

export class MedicFavoriteStandardPrescriptionRequest {
    public listFavoriteStandardMedicine: FavoriteStandardMedicine[] = [];
    public listMedicatedSolutionPrescription: FavoriteMedicatedSolutionStruct[] = [];
    public favoriteMedicineName: string;
    public idMedicFavoriteStandardPrescription: number;
    public shareWithMedicalTeam: boolean;
}